import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

import { JobManagementSectionView } from "./JobManagementSectionView";

interface JobManagementSectionContainerProps {
  workplaceId: string;
}

export function JobManagementSectionContainer({ workplaceId }: JobManagementSectionContainerProps) {
  const isParentManagedPlacementsEnabled = useCbhFlag(
    CbhFeatureFlag.ROLLOUT_PARENT_MANAGED_PLACEMENTS,
    { defaultValue: false }
  );

  return (
    <JobManagementSectionView
      showChildFacilitiesSelect={isParentManagedPlacementsEnabled}
      workplaceId={workplaceId}
    />
  );
}
